/**
 * Created by jonas on 2021-02-02.
 */

export interface DasUBootXWayData {
    positions:[number, number] //Reel 1 & 4
    size:number
    symbol:string
    symbolB:number //binary
}


export interface DasUBootXNudgeData {
    doReelNudge:[boolean, boolean]; //reel 2 & 3
    multipliers:[number, number];
    rowHits:[number, number];
    totalMultiplier:number;
    up:[boolean, boolean];
    w4Pos:[number, number]; //Added by client.
}


export interface DasUBootTorpedoData {
    isComplete:boolean;
    multiplierReel3:number;
    multiplierReel4:number;
    sizeNose:number;
    sizeTail:number;
    symbolMid:"T"
    //symbolMidB: 35184525480521
    //symbolNoseB: 0
    symbolNose:string;
    //symbolTailB: 0
    symbolTail:string;
    torpedoParts:boolean[];
    xWaysHits:boolean[][]; //6x4
}

export enum DasUBootRoundType {
    NORMAL= 0,
    FREE_SPIN= 1,
    SUPER_FREE_SPIN = 2
}

export interface DasUBootPeriscopeData {
    hasScope:boolean;
    hit:boolean;
    hitChance:number; //percent
    nudge:number;
}

export interface DasUBootData {
    accumulatedRoundWin:number;
    featureBuyTimesBetValue:{name:string, type:string, price:number}[];
    freespinTriggeredThisSpin:boolean;
    freespinsLeft:number;
    gameAreaSize:number[]; //visible symbols per reel.
    mode:string;
    nextMode:string;
    numberOfFreespinPlayed:number;
    reels:string[][];
    reelsNextSpin:string[];

    collapsedAreaAfterBomb?:string[][];

    xNudges?:DasUBootXNudgeData;
    mystery?:DasUBootXWayData;

    torpedo?:DasUBootTorpedoData;

    periscope?:DasUBootPeriscopeData;

    stickyFSMultiplier:number;

    reelsEnteringFreespin?:string[][];

    roundType:DasUBootRoundType;

    wasFeatureBuy: boolean;
}



export function isDasUBootInitData(value:any):value is DasUBootInitData {
    return value.symbolValues !== undefined;
}
export function isDasUBootGameData(value:any):value is DasUBootGameData {
    return value.betWayWins !== undefined;
}

export interface DasUBootInitData extends DasUBootData {
    featureBuyTimesBetValue:{name:string, type:string, price:number}[];
    freespinTriggeredThisSpin:boolean;
    //freespinsLeft:number;
    //gameAreaSize:number[];
    isRestoreState:boolean;
    //mode:string;
    //mysterySymbolRevealed:string;
    //nextMode:string;
    //numberOfFreespinPlayed:number;
    //reels:string[][];
    //reelsNextSpin:string[];
    symbolValues:{[key:string]:{3:number, 4:number, 5:number, 6:number}};

}

export interface DasUBootGameData extends DasUBootData {
    addedNumberOfFreespinsThisSpin:number;
    betWayWins:BetWayWinData[];
    doReelNudge:boolean[];
    evaluatedArea:string[][];
    featureBet:boolean;
    //featureBuyTimesBetValue:{name:string, type:string, price:number}[];
    //freespinTriggeredThisSpin:boolean;
    //freespinsLeft:number;
    fsWildMultiplierPayout:number[][]; //Is a 6 x 4 matrix.
    //gameAreaSize:number[]; //visible symbols per reel.

    //mode:string;

    nearWinReels:boolean[];
    //nextMode:string;
    //numberOfFreespinPlayed:0;
    payoutMultiplier:number;
    playedBetValue:number;

    //reels:string[][];
    //reelsNextSpin:string;

    scatterPositions:number[];

    stickyWildPositions:boolean[];

    superFreespin:boolean;
    superXwayTrigger:boolean;
    superXways:number[];

    totalSpinWinnings:number;
    totalSpinWinningsNonMultiplied:number;

    xBombMultiplier:number;
    xBombTriggered:boolean;

}


export interface ClientXWays {
    reel:number;
    position:number;
    symbol:string;
    size:number;
}

export interface ClientTorpedoPart {
    reel:number;
    size:number;
    landingSize:number;
    addedThisSpin?:{
        position:number;
        fallSize:number;
    };
    firedThisSpin?:{
        symbol:string;
    }
}

export interface ClientXNudge {
    reel:number;
    up:boolean;
    steps:number;
    isInWin:boolean;
    w4StartPos:number;
    w4EndPos:number;
}

export interface BetWayWinData {
    amount:number;
    length:number;
    mode:string;
    multipliedAmount:number;
    multiplier:number;
    numberOfCombinations:number;
    reelWinPositions:boolean[][];
    symbol:string;
}
